export type ErrorClassification = 'AUTH_ERROR' | 'NETWORK_ERROR' | 'SERVER_ERROR' | 'CHUNK_ERROR' | 'UNKNOWN_ERROR';

/**
 * Centralized utility to classify all errors into discrete application failure types.
 */
export const classifyError = (error: unknown): ErrorClassification => {
  if (!error || typeof error !== 'object') return 'UNKNOWN_ERROR';

  const err = error as Record<string, unknown>;

  // React ChunkLoadError
  if (err.name === 'ChunkLoadError' || (typeof err.message === 'string' && err.message.includes('Loading chunk'))) {
    return 'CHUNK_ERROR';
  }

  // RTK Query FetchBaseQueryError
  if ('status' in err) {
    const status = err.status;
    if (status === 401 || status === 403) {
      return 'AUTH_ERROR';
    }
    // CORS preflight blocks or network disconnection typically result in 'FETCH_ERROR'
    if (status === 'FETCH_ERROR' || status === 'TIMEOUT_ERROR' || status === 'PARSING_ERROR') {
      return 'NETWORK_ERROR';
    }
    if (typeof status === 'number' && status >= 500) {
      return 'SERVER_ERROR';
    }
  }

  // Fallback for native Fetch / Axios generic network errors
  if (err.name === 'TypeError' && err.message === 'Failed to fetch') {
    return 'NETWORK_ERROR';
  }

  return 'UNKNOWN_ERROR';
};
